import styled, { css } from 'styled-components';

export const BUTTON_SIZE = {
  xs: 20,
  s: 24,
  m: 32,
  l: 40,
  xl: 48,
};

const BtnWrapper = styled.button<{
  outlined: boolean;
  size: SizeType;
  rounded: boolean;
  css?: StyledCss;
}>`
  cursor: pointer;
  border-radius: ${({ rounded }) => (rounded ? '64px' : '6px')};
  color: ${(props) => props.theme.colors.gray700};
  transition: 0.2s all;
  :disabled {
    color: ${(props) => props.theme.colors.gray500};
    pointer-events: auto;
    cursor: not-allowed;
  }
  :hover {
    background-color: ${(props) => props.theme.colors.ND08};
  }

  ${({ outlined, theme }) =>
    outlined
      ? css`
          border: 1px solid ${theme.colors.gray400};

          :disabled {
            color: ${theme.colors.gray300};
            border: 1px solid ${(props) => props.theme.colors.gray300};
          }
        `
      : css`
          :hover: {
            background-color: ${theme.colors.ND04};
          }
        `}

  ${({ size }) => {
    switch (size) {
      case 'xs':
        return css`
          font-size: 10px;
          width: ${BUTTON_SIZE.xs}px;
          height: ${BUTTON_SIZE.xs}px;
        `;
      case 's':
        return css`
          font-size: 12px;
          width: ${BUTTON_SIZE.s}px;
          height: ${BUTTON_SIZE.s}px;
        `;
      case 'm':
        return css`
          font-size: 14px;
          width: ${BUTTON_SIZE.m}px;
          height: ${BUTTON_SIZE.m}px;
        `;
      case 'l':
        return css`
          font-size: 16px;
          width: ${BUTTON_SIZE.l}px;
          height: ${BUTTON_SIZE.l}px;
        `;
      case 'xl':
        return css`
          font-size: 16px;
          width: ${BUTTON_SIZE.xl}px;
          height: ${BUTTON_SIZE.xl}px;
        `;
    }
  }}
  ${({ css }) => css && css};
`;

const SingleIconBtnStyle = {
  BtnWrapper,
};

export default SingleIconBtnStyle;
